import { usePost } from '@/lib/hooks/useFetch';
import { AxiosApiError } from '@/lib/config/types';
import { getErrorMessage } from '@/lib/utils';
import toast from 'react-hot-toast';
import { RetrieveTokenParams, RetrieveTokenResponse } from './types';

/**
 * Hook para trocar o UUID (exchange code) pelos tokens de autenticação
 */
export const useRetrieveToken = () => {
    return usePost<RetrieveTokenResponse, AxiosApiError, RetrieveTokenParams>({
        key: ['retrieve-token'],
        url: 'auth/retrieve-token',
        options: {
            onSuccess: () => {
                console.log('[Auth] Token retrieved successfully');
            },
            onError: (e) => {
                console.error('[Auth] Retrieve token error', e);
                toast.error(getErrorMessage(e, 'Erro ao recuperar token de autenticação.'));
            },
        },
    });
};
